import m from "mithril";

const PaginationBar = {
    view: function (vnode) {
        const { page, totalPages, totalRecords, limit, onPageChange, itemLabel = "data" } = vnode.attrs;
        const effectiveTotal = totalPages || 1;
        const from = totalRecords === 0 ? 0 : ((page - 1) * limit) + 1;
        const to = Math.min(page * limit, totalRecords || 0);

        return m("div", { class: "bg-white dark:bg-gray-800 px-4 py-3 border-t border-gray-200 dark:border-gray-700 sm:px-6 flex flex-col sm:flex-row items-center justify-between" }, [
            m("div", { class: "flex-1 flex justify-between sm:hidden w-full mb-4 sm:mb-0" }, [
                m("button", {
                    class: `relative inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-md bg-white dark:bg-gray-800 ${page <= 1 ? 'text-gray-300 dark:text-gray-600 cursor-not-allowed' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'}`,
                    disabled: page <= 1,
                    onclick: () => { if (page > 1) onPageChange(page - 1); }
                }, "Sebelumnya"),
                m("button", {
                    class: `ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-md bg-white dark:bg-gray-800 ${page >= effectiveTotal ? 'text-gray-300 dark:text-gray-600 cursor-not-allowed' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'}`,
                    disabled: page >= effectiveTotal,
                    onclick: () => { if (page < effectiveTotal) onPageChange(page + 1); }
                }, "Selanjutnya")
            ]),
            m("div", { class: "hidden sm:flex-1 sm:flex sm:items-center sm:justify-between w-full" }, [
                m("div", [
                    m("p", { class: "text-sm text-gray-700 dark:text-gray-300" }, [
                        "Menampilkan ",
                        m("span", { class: "font-medium" }, from),
                        " sampai ",
                        m("span", { class: "font-medium" }, to),
                        " dari ",
                        m("span", { class: "font-medium" }, totalRecords),
                        ` ${itemLabel}`
                    ])
                ]),
                m("div", [
                    m("nav", { class: "relative z-0 inline-flex rounded-md shadow-sm -space-x-px", "aria-label": "Pagination" }, [
                        m("button", {
                            class: `relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm font-medium ${page <= 1 ? 'text-gray-300 dark:text-gray-500 cursor-not-allowed' : 'text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'}`,
                            disabled: page <= 1,
                            onclick: () => { if (page > 1) onPageChange(page - 1); }
                        }, [
                            m("span", { class: "sr-only" }, "Previous"),
                            m("i", { class: "ri-arrow-left-s-line" })
                        ]),
                        m("span", { class: "relative inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm font-medium text-gray-700 dark:text-gray-300" },
                            `Halaman ${page} dari ${effectiveTotal}`
                        ),
                        m("button", {
                            class: `relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm font-medium ${page >= effectiveTotal ? 'text-gray-300 dark:text-gray-500 cursor-not-allowed' : 'text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'}`,
                            disabled: page >= effectiveTotal,
                            onclick: () => { if (page < effectiveTotal) onPageChange(page + 1); }
                        }, [
                            m("span", { class: "sr-only" }, "Next"),
                            m("i", { class: "ri-arrow-right-s-line" })
                        ])
                    ])
                ])
            ])
        ]);
    }
};

export default PaginationBar;